export default __webpack_public_path__ + "static/media/featured-3.cb2f5858.jpeg";